import Button from "../../components/Button";
import Label from "../../components/Label";
import Icon from "../../components/Icon";
import styles from "./wizardButton.module.css";

const WizardButton = ({ step, caption, disabled, length, ...rest }) => {
  return (
    <div className={styles.wizardButton}>
      {step > 1 ? (
        <Icon
          arrowRight
          style={{
            opacity: `${disabled ? "0.3" : "unset"}`,
            marginRight: "var(--gap-base)",
          }}
        />
      ) : null}
      <Button rounded {...rest} id={`wb-${caption}`} disabled={disabled}>
        {step}
      </Button>
      <Label
        checkboxLabel
        htmlFor={`wb-${caption}`}
        style={{
          padding: "var(--gap-base)",
          pointerEvents: `${disabled ? "none" : "auto"}`,
          cursor: `${disabled ? "unset" : "pointer"}`,
          opacity: `${disabled ? "0.3" : "unset"}`,
        }}
      >
        {caption}
      </Label>
    </div>
  );
};

export default WizardButton;
